export const thousand = 1000;
export const DETAILS_VOLUME_MIN = 0;
